import { setItem } from '@alltrails/local-storage/utils';

export default function markPostAuthUpsellSeen() {
  setItem('post-auth-upsell', new Date().getTime());
}
